import { Directive, ElementRef, OnInit, AfterViewChecked, HostListener } from '@angular/core';

@Directive({
  selector: '[table-scroll]',
})
export class TableScrollDirective implements OnInit, AfterViewChecked {

  private _el: HTMLElement;

  constructor(
    el: ElementRef) {
    this._el = el.nativeElement;
  }

  ngOnInit() {
    this.calculateHeight();
  }

  ngAfterViewChecked() {
    this.onScroll();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.calculateHeight();
  }

  @HostListener('scroll')
  onScroll(): void {
    const translateY = 'translateY(' + (this._el.scrollTop + 0) + 'px)';
    const translateX = 'translateX(' + (this._el.scrollLeft + 0) + 'px)';

    this.translate(
      this._el.getElementsByClassName('freeze_horizontal'),
      translateX);

    this.translate(
      this._el.getElementsByClassName('freeze_vertical'),
      translateY);

    this.translate(
      this._el.getElementsByClassName('freeze'),
      translateX + ' ' + translateY);
    const foots = this._el.getElementsByTagName('tfoot');
    const translateBy = 'translateY(' + (-(this._el.scrollHeight - this._el.clientHeight - this._el.scrollTop)) + 'px)';
    for (let i = 0; i < foots.length; i++) {

      this.translate(
        foots.item(i).getElementsByClassName('freeze_vertical'),
        translateBy);

      this.translate(
        foots.item(i).getElementsByClassName('freeze'),
        translateX + ' ' + translateBy);
    }
  }

  private translate(items: HTMLCollectionOf<Element>, value) {
    for (let i = 0; i < items.length; i++) {
      const item = items.item(i) as HTMLElement;
      item.style.webkitTransform = value;
      item.style.transform = value;
    }
  }

  calculateHeight(): any {
    if (!this._el.style.height && !this._el.style.maxHeight) {
      const breadcrumb = document.querySelector('.breadcrumb');
      let height = window.innerHeight -
        // document.querySelector("nav").clientHeight -
        // document.querySelector("footer").clientHeight -
        62 -
        44;
      if (breadcrumb) {
        height -= breadcrumb.clientHeight;
      }
      const tableNavigationElement = document.querySelector('.table-navigation');
      if (tableNavigationElement) {
        height -= tableNavigationElement.clientHeight;
      }

      height = height - 98;

      this._el.style.maxHeight = height + 'px';
    }
  }
}
